import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { Field, InputType } from 'type-graphql'

@InputType()
export class ForceRecomputeAllProductQuantitiesArgs extends ActionArgs {
  @Field(() => Boolean, { nullable: true })
  skipPermissionCheck?: boolean
}

export interface IForceRecomputeAllProductQuantities
  extends IAction<string | null, ForceRecomputeAllProductQuantitiesArgs> {}
